<template>
  <div>
    <app-header></app-header>
    <mobile-header></mobile-header>

    <sidebar></sidebar>
    <mobile-aside></mobile-aside>

    <div id="app_content">
      <div class="container">
        <slot></slot>
      </div>
    </div>

    <div class="text-center" id="whatsapp_link">
      <a :href="width < 480 ? 'https://wa.me/989309086008' : 'https://web.whatsapp.com/send?phone=989309086008'" target="_blank">
        <whatsapp></whatsapp>
      </a>
    </div>
  </div>
</template>

<script>
import sidebar from "@/components/main/aside-marketing.vue";
import mobileAside from '@/components/main/mobile-aside-marketing';
import appHeader from "@/components/main/header";
import mobileHeader from '@/components/main/mobile-header';
import whatsapp from './main/whatsapp';

export default {
  name: 'mainContentMarketing',
  components: {
    sidebar,
    mobileAside,
    mobileHeader,
    appHeader,
    whatsapp,
  },
  data() {
    return {
      width: window.innerWidth,
    }
  },
  created() {
    window.addEventListener("resize", this.myResizeEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myResizeEventHandler);
  },
  methods: {
    myResizeEventHandler(event) {
      this.width = window.innerWidth;
    },
  },
}
</script>

<style>

@media (max-width: 800px) {
  .bg-1 .bg-form.bg-white.shadow {
    padding-bottom: 50px;
    height: auto;
  }
}
</style>
